import { blockPageZoom } from '@frontends/feature-tv-parts';
import '@frontends/feature-tv-parts/style';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './App';
import { store } from './app/store';
import './assets/styles/app.css';
import './i18n';

blockPageZoom(document);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
